<template>
  <d2-container>
    <div class="login-container">
      <div class="loginbasecont">
        <div class="logincontLft">
          <div class="logincontCon1">让我们一起开启智能未来</div>
          <div style="height: 32px;" />
          <div class="logincontCon3">加入算力城市大家庭，携手共创智能新世界</div>
        </div>

        <el-card class="box-card">
          <template>
            <div class="card-header">
              <span>算力城市</span>
            </div>
            <div style="text-align: center;">
              <img src="/image/portalimg/regsusser.png" style="display: block;width: 130px;margin: 0 auto 50px;">
              <p>注册成功，请 <a href="https://console.ltaidc.com" target="_blank" style="curpor: pointer; color: #409EFF;">登录</a></p>
            </div>
          </template>
        </el-card>
      </div>
    </div>
  </d2-container>
</template>

<script>
import { Base64 } from 'js-base64'
import { aesEncrypt } from '@/utils/crypto'


export default {
  name: 'hosting',
  data() {
    return {
      form: {
        username: '',
        password: '',
        email: '',
        description: '',
        displayname: '',
        real_name: '',
        id_number: '',
        phone: '',
        verification_code: '',
        address: '',
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('[submitForm]', this.form.username, this.form.password);

          const pwCode = aesEncrypt(this.form.password)
          console.log('[submitForm]', pwCode)

          // this.$axios({
          //   method: 'get',
          //   url: 'http://192.168.4.54:8089/users',
          //  // url: 'https://lthpc.atcloud.xyz/users'
          // }).then(res => {
          //   console.log('[submitForm - regions]', res)

          //   this.$axios({
          //     method: 'post',
          //     url: 'http://192.168.4.54:8089/auth',
          //     // url: 'https://lthpc.atcloud.xyz:30300/api/v1/auth/login',
          //     data: {
          //       username: this.form.username,
          //       password: pwCode
          //     }
          //   }).then(res => {
          //     console.log("[submitForm - response]", res)
          //     if (res.code === 200) {
          //       console.log("[submitForm]: Success!")
          //     }
          //   })
          // })

          this.$axios({
              method: 'post',
              url: 'http://192.168.4.54:8089/create_user',
              // url: 'https://lthpc.atcloud.xyz:30300/api/v1/auth/login',
              data: {
                name: this.form.username,
                password: pwCode,
                description: this.form.description,
                displayname: this.form.displayname,
                real_name: this.form.real_name,
                id_number: this.form.id_number,
                phone: this.form.phone,
                verification_code: this.form.verification_code,
                address: this.form.address,
              }
            }).then(res => {
              console.log("[submitForm - response]", res)
              if (res.code === 200) {
                console.log("[submitForm]: Success!")
              }
            })

        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: url(/image/portalimg/loginin.png) no-repeat;
  background-size: 100% 100%;
}
.loginbasecont{
  width:1560px;
  height: 100vh;
  margin:0 auto;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logincontLft{
  width: 766px;
  float: left;
  margin-right: 200px;
}
.loginconttitle{
  font-size: 24px;
  color: #05004B;
  letter-spacing: 2.8px;
  line-height: 86px;
  font-weight: 400;
}
.logincontCon1{
  font-size: 48px;
  color: #05004B;
  letter-spacing: 2.8px;
  line-height: 86px;
  font-weight: 500;
}
.logincontCon2{
  font-size: 48px;
  color: #05004B;
  letter-spacing: 2.8px;
  line-height: 86px;
  font-weight: 500;
}
.logincontCon3{
  font-size: 24px;
  color: #05004B;
  letter-spacing: 2.8px;
  line-height: 86px;
  font-weight: 400;
}

.box-card {
  width: 420px;
  height: 500px;
  float: right;

}
.card-header{
  text-align: center;
  padding: 60px 0;
}
.card-header span{
  font-size: 24px;
  color: #000000;
  letter-spacing: 4px;
  font-weight: 600;
}
.login-btn{
  color: #fff !important;
}
.login-btn span{
  color: #fff !important;
}
</style>
